import PDFError from './pdfError';
import {
    Box,
    Modal
} from '@mui/material';

import React, { useEffect, useRef, forwardRef } from 'react';

const PDF = ({ data }) => {
    const STYLE = {
        position: 'absolute',
        width: '60%',
        height: '95%',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    };

    return (
        <Box sx={STYLE} >
            <object
                data={`data:application/pdf;base64,${data}`}
                type="application/pdf"
                width='100%'
                height='100%'
            />
        </Box>
    )
}



const SFCC_FRAME = forwardRef(({ htmlContent, ...props }, ref) => {
    const internalRef = useRef(null);
    const shadowRef = useRef(null);

    useEffect(() => {
        const host = internalRef.current;
        if (!host) return;

        if (!shadowRef.current) {
            shadowRef.current = host.attachShadow({ mode: 'open' });
        }

        shadowRef.current.innerHTML = `
            <style>
                :host { 
                    display: block; 
                    width: 100%; 
                    height: 100%; 
                    overflow-y: auto; 
                    background: black;
                }

                .document-wrapper {
                    width: 100%;
                    box-sizing: border-box;
                }

                a { 
                    pointer-events: none !important; 
                    text-decoration: none !important; 
                    cursor: default !important; 
                    color: inherit !important;
                }
            </style>
            <div class="document-wrapper" style="padding-top: 45px;">
                ${htmlContent || '<div style="padding: 20px; font-family: sans-serif;">Loading document...</div>'}
            </div>
        `;
    }, [htmlContent]);

    return (
        <div 
            ref={(node) => {
                internalRef.current = node;
                if (typeof ref === 'function') ref(node);
                else if (ref) ref.current = node;
            }} 
            style={{ 
                position: 'absolute',
                width: '60%',
                height: '95%',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }} 
            {...props}
        />
    );
});



export default function PDFModal(props) {
    const {
        data,
        open,
        handleClose,
        id,
        dataType,
        source,
        error
    } = props;

    const render = () => {
        if (error) {
            return (
                <PDFError
                    id={id}
                    dataType={dataType}
                    handleButtonClick={handleClose}
                />
            )
        } else if (source?.toUpperCase() === 'SFCC') {
            return (
                <SFCC_FRAME htmlContent={data} />
            )
        
        } else {
            return (
                <PDF data={data} />
            )
        }
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
            {render()}
        </Modal>
    )    
}
